<template>
  <div>
    <div class="form-group row" v-if="!multiple">
      <label class="col-sm-4 col-form-label">
        {{ c.label }}<small v-if="c.required" class="text-danger">*</small>
      </label>
      <div class="col-sm-8 my-auto" v-if="choice == 'yes_no'">
        <select
          v-if="!confirm"
          v-model="visitor_forms[c.id]"
          :required="c.required ? true : false"
          class="form-control"
        >
          <option value="">--</option>
          <option v-for="n in changeChoices('yes_no')" :value="n.value">
            {{ n.value }}
          </option>
        </select>
        <p v-if="confirm" class="mb-0">
          {{ getChoice("yes_no", visitor_forms[c.id]) }}
        </p>
      </div>
      <div class="col-sm-8 my-auto" v-if="choice == 'choices2'">
        <select
          v-if="!confirm"
          v-model="visitor_forms[c.id]"
          :required="c.required ? true : false"
          class="form-control"
        >
          <option value="">--</option>
          <option v-for="n in changeChoices('choices2')" :value="n">
            {{ n }}
          </option>
        </select>
        <p v-if="confirm" class="mb-0">
          {{ getChoice("choices2", visitor_forms[c.id]) }}
        </p>
      </div>
      <!-- For data aggregation -->
      <template v-if="guestLength > 0 && !confirm">
        <template v-for="(companion, index) in companions">
          <label
            v-if="!confirm && canBeCopy.includes(c.system_name)"
            class="form-check-label mt-1 col-sm-8 offset-sm-4"
            @click="
              copyFromMain(
                c.id,
                companion.other_forms,
                { type: 'visitor', obj: visitor_forms[c.id] },
                $event
              )
            "
          >
            {{ $t("visit-information-form.copy-from-main") }}
          </label>
          <label class="col-sm-4 col-form-label">
            {{ c.label }}<small v-if="c.required" class="text-danger">*</small>
            <div>
              ({{
                showLabelOrPlaceholder(
                  $t("visit-information-form.companion"),
                  index,
                  "",
                  "dropdown"
                )
              }})
              <small v-if="c.required" class="text-danger">*</small>
            </div>
          </label>
          <div class="col-sm-8" v-if="choice == 'yes_no'">
            <select
              v-if="!confirm && different.includes(c.system_name)"
              v-model="companion.other_forms[c.id]"
              :required="c.required ? true : false"
              class="form-control mt-1"
            >
              <option value="">--</option>
              <option v-for="n in changeChoices('yes_no')" :value="n.value">
                {{ n.value }}
              </option>
            </select>
          </div>
          <div class="col-sm-8" v-if="choice == 'choices2'">
            <select
              v-if="!confirm"
              v-model="companion.other_forms[c.id]"
              :required="c.required ? true : false"
              class="form-control mt-1"
            >
              <option value="">--</option>
              <option v-for="n in changeChoices('choices2')" :value="n">
                {{ n }}
              </option>
            </select>
          </div>
        </template>
      </template>
    </div>

    <!-- Multiple Room -->
    <div class="form-group row" v-else>
      <label class="col-sm-4 col-form-label">
        {{ c.label }}<small v-if="c.required" class="text-danger">*</small>
      </label>
      <div class="col-sm-8" v-if="choice == 'yes_no'">
        <select
          v-if="!confirm"
          v-model="multiple_data[bd_index].visitor_forms[c.id]"
          :required="
            multiple_data[bd_index].filled_in_by_other
              ? false
              : c.required
              ? true
              : false
          "
          class="form-control"
        >
          <option value="">--</option>
          <option v-for="n in changeChoices('yes_no')" :value="n.value">
            {{ n.value }}
          </option>
        </select>
        <p v-if="confirm">
          {{ getChoice("yes_no", multiple_data[bd_index].visitor_forms[c.id]) }}
        </p>
      </div>
      <div class="col-sm-8" v-if="choice == 'choices2'">
        <select
          v-if="!confirm"
          v-model="multiple_data[bd_index].visitor_forms[c.id]"
          :required="
            multiple_data[bd_index].filled_in_by_other
              ? false
              : c.required
              ? true
              : false
          "
          class="form-control"
        >
          <option value="">--</option>
          <option v-for="n in changeChoices('choices2')" :value="n">
            {{ n }}
          </option>
        </select>
        <p v-if="confirm">
          {{
            getChoice("choices2", multiple_data[bd_index].visitor_forms[c.id])
          }}
        </p>
      </div>
      <!-- For data aggregation -->

      <template
        v-if="multiple_data[bd_index].companions.length > 0 && !confirm"
      >
        <template
          v-for="(companion, index) in multiple_data[bd_index].companions"
        >
          <label
            v-if="!confirm && canBeCopy.includes(c.system_name)"
            class="form-check-label mt-1 col-sm-8 offset-sm-4"
            @click="
              copyFromMain(
                c.id,
                companion.other_forms,
                {
                  type: 'visitor',
                  obj: multiple_data[bd_index].visitor_forms[c.id],
                },
                $event
              )
            "
          >
            {{ $t("visit-information-form.copy-from-main") }}
          </label>
          <label class="col-sm-4 col-form-label">
            {{ c.label }}<small v-if="c.required" class="text-danger">*</small>
            <div>
              ({{
                showLabelOrPlaceholder(
                  $t("visit-information-form.companion"),
                  index,
                  "",
                  "dropdown",
                  true,
                  bd_index
                )
              }})
              <small v-if="c.required" class="text-danger">*</small>
            </div>
          </label>
          <div class="col-sm-8" v-if="choice == 'yes_no'">
            <select
              v-if="!confirm && different.includes(c.system_name)"
              v-model="companion.other_forms[c.id]"
              :required="c.required ? true : false"
              class="form-control mt-1"
            >
              <option value="">--</option>
              <option v-for="n in changeChoices('yes_no')" :value="n.value">
                {{ n.value }}
              </option>
            </select>
          </div>
          <div class="col-sm-8" v-if="choice == 'choices2'">
            <select
              v-if="!confirm"
              v-model="companion.other_forms[c.id]"
              :required="c.required ? true : false"
              class="form-control mt-1"
            >
              <option value="">--</option>
              <option v-for="n in changeChoices('choices2')" :value="n">
                {{ n }}
              </option>
            </select>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { main_form_methods } from "../../../../utils/mockup";
import guestWatcherMixin from "../../../../../../mixins/guestWatcherMixin";

const { 
  showLabelOrPlaceholder, 
  changeChoices, 
  getChoice, 
  copyFromMain, 
  populateCompanionsFields, 
  isFixGuestEnabled,
  checkAddCompanions,
  isRsvForm,
  getLength
 } = main_form_methods;

export default {
  props: {
    c: null,
    confirm: false,
    visitor_forms: {
      type: Object,
      default: {},
    },
    companions: {
      type: Array,
      default: [],
    },
    different: {
      type: Array,
      default: [],
    },
    questions: {
      type: Array,
      default: [],
    },
    choice: null,
    canBeCopy: {
      type: Array,
      default: [],
    },
    // Multiple room
    multiple: false,
    multiple_data: {
      type: Array,
      default: [],
    },
    bd_index: null,
    // End of multiple room

    // checkin form type
    checkin_form_type: "",
    reservation_no: null,
    fixGuestCount: {
      type: Number,
      default: null
    },
    fixGuestSetting: {
      type: Object,
      default: {}
    }
  },
  mixins: [guestWatcherMixin],
  data() {
    return {
      formType: "",
      allowAddingCompanions: true,
      guestLength: 0
    };
  },
  computed: {
    isFixGuestEnabled,
    isRsvForm,
    getLength
    // fixGuestLength() {
    //   this.guestLength = this.fixGuestCount
    // },
  },
  async created() {
    await this.initializeForm();
  },
  methods: {
    async initializeForm() {

      const isRsvForm = await this.isRsvForm
      const isFixGuestEnabled = await this.isFixGuestEnabled
  
      this.allowAddingCompanions = this.checkAddCompanions(isRsvForm, isFixGuestEnabled);
      this.populateCompanionsFields();
    },
    showLabelOrPlaceholder,
    populateCompanionsFields,
    changeChoices,
    getChoice,
    copyFromMain,
    checkAddCompanions,
  },
};
</script>

<style scoped>
.form-check-label {
  text-decoration: underline;
  cursor: pointer;
}
</style>
